$(document).ready(function() {

    var currentDomain = window.location.hostname;

    // Configuration for markets
    var markets = {
        'www.purition.co.uk': {
            countryIso: 'GB',
            flagUrl: 'https://cdn.shopify.com/s/files/1/0458/0969/6936/files/uk-flag.jpg?v=1712236932',
            altText: 'United Kingdom flag',
            redirectUrl: 'https://www.purition.co.uk/?countryIso=GB'
        },
        'www.purition.com': {
            countryIso: 'US',
            flagUrl: 'https://cdn.shopify.com/s/files/1/0458/0969/6936/files/usa-flag-30.webp?v=1712062971',
            altText: 'United States flag',
            redirectUrl: 'https://www.purition.com/?countryIso=US'
        },
        'www.purition.eu': {
            countryIso: 'EU',
            flagUrl: 'https://cdn.shopify.com/s/files/1/0458/0969/6936/files/eu-flag-30.webp?v=1712062971',
            altText: 'European Union flag',
            redirectUrl: 'https://www.purition.eu/?countryIso=EU'
        }
    };

    var otherMarkets = [];
    for (var domain in markets) {
        if (domain !== currentDomain) {
            otherMarkets.push(markets[domain]);
        }
    }

    // Populate the dropdown with the appropriate market options
    otherMarkets.forEach(function(market) {
        $('.loc-dropdown-menu').append('<li class="loc-drop"><span><img src="' + market.flagUrl + '" alt="' + market.altText + '"></span></li>');
    });

    // Dropdown interaction
    $('.loc-dropdown').click(function() {
        $(this).attr('tabindex', 1).focus();
        $(this).toggleClass('active');
        $(this).find('.loc-dropdown-menu').slideToggle(300);
    });

    $('.loc-dropdown').focusout(function() {
        $(this).removeClass('active');
        $(this).find('.loc-dropdown-menu').slideUp(300);
    });

    // Handle li click, redirect to the appropriate market URL
    $('.loc-dropdown .loc-dropdown-menu li').click(function() {
        var index = $(this).index();
        if (otherMarkets[index]) {
            window.location.href = otherMarkets[index].redirectUrl;
        }
    });

    // Dynamically display the flag of the current market in the loc-select div
    var currentMarket = markets[currentDomain];
    if (currentMarket) {
        $('.loc-dropdown .loc-select span:first-child img').attr('src', currentMarket.flagUrl).attr('alt', currentMarket.altText);
    } else {
        $('.loc-dropdown .loc-select span:first-child').html('<img src="https://cdn.shopify.com/s/files/1/0458/0969/6936/files/no-flag-30.png?v=1692366988" alt="No flag">');
    }

});
